import React from 'react';
import PropTypes from 'prop-types';
const Moment = require('moment');

import DateString from '../common/DateString';
import AccessButton from '../common/AccessButton';

const propTypes = {
    channelId: PropTypes.string.isRequired,
    projectId: PropTypes.string.isRequired,
    shortCourse: PropTypes.object.isRequired,
};

const defaultProps = {

};

function ShortCourseListing(props) {
    if (!props.shortCourse) {
        return <li />;
    }

    return (
        <li>
            <a name={`#${props.shortCourse.id}`} />
            <div className="listing activity-listing">
                <div className="left-content">
                    <div className="icon-container">
                    </div>
                    <div className="project-info">
                        <div className="project-title">{props.shortCourse.title}</div>
                        <div className="modified-info">
                            <span>Created: <DateString date={props.shortCourse.created_at} /></span>
                        </div>
                        <div className="modified-info">
                            <span>Last Updated: 
                                {(!!props.shortCourse.modified_at) ?
                                     <DateString date={props.shortCourse.modified_at} />
                                     :
                                     <DateString date={props.shortCourse.created_at} />
                                }
                            </span>
                        </div>
                    </div>
                </div>
                <div className="right-content">
                    <AccessButton
                        iconPath={`${GlobalConfig.StaticUrl}/img/Open.svg`}
                        iconStyle={{width:'24px'}}
                        text="open"
                        href={`/project/${props.channelId}/${props.projectId}/short_course/${props.shortCourse.id}`}
                    />
                </div>
            </div>
        </li>
    );
}

ShortCourseListing.propTypes = propTypes;
ShortCourseListing.defaultProps = defaultProps;

export default ShortCourseListing;
